var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.click}},[_c('img',{staticClass:"icon",attrs:{"alt":_vm.translations.icon,"src":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }